import {
  Edit,
  SimpleForm,
  DateInput,
  TextInput,
  required,
  minLength,
  maxLength,
  useRecordContext,
  useGetOne,
} from "react-admin";
import { TextField as MuiTextField } from "@mui/material";
import { Col, Row } from "../../components/grid.component";

const validateTrackingCode = [required(), minLength(3), maxLength(255)];
const validatePlugNumber = [required(), minLength(3), maxLength(255)];
const validateDate = [required()];

const ReadOnlyField = ({ label, value }: { label: string; value: string | number }) => (
  <MuiTextField
    label={label}
    value={value ?? ''}
    disabled
    fullWidth
    variant="filled"
  />
);

const LicenseDetailsDisplay = () => {
  const record = useRecordContext();
  const licenseId = record?.licenseId ?? record?.license_id ?? record?.license?.id;

  const { data: license, isLoading } = useGetOne(
    'licenses',
    { id: licenseId },
    { enabled: !!licenseId }
  );

  const productId = license?.productId ?? license?.product?.id;

  const { data: product, isLoading: isLoadingProduct } = useGetOne(
    'products',
    { id: productId },
    { enabled: !!productId }
  );

  const loading = (flag: boolean) => flag ? 'Carregando...' : '';

  return (
    <>
      <Row spacing={3}>
        <Col sm={6}>
          <ReadOnlyField
            label="Usuário"
            value={isLoading ? 'Carregando...' : (license?.user?.name || '')}
          />
        </Col>
        <Col sm={6}>
          <ReadOnlyField
            label="CPF/CNPJ"
            value={isLoading ? 'Carregando...' : (license?.user?.registration || '')}
          />
        </Col>
      </Row>
      <Row spacing={3}>
        <Col sm={6}>
          <ReadOnlyField
            label="Produto"
            value={isLoadingProduct ? 'Carregando...' : (product?.name || loading(isLoading))}
          />
        </Col>
        <Col sm={6}>
          <ReadOnlyField
            label="Código do serial"
            value={isLoading ? 'Carregando...' : (license?.serialNumber || '')}
          />
        </Col>
      </Row>
      <Row spacing={3}>
        <Col sm={6}>
          <ReadOnlyField
            label="Versão"
            value={isLoading ? 'Carregando...' : (license?.version ?? '')}
          />
        </Col>
      </Row>
    </>
  );
};

const transform = (data: any) => ({
  ...data,
  tracking_code: data.trackingCode,
  plug_number: data.plugNumber,
  shipment_date: data.shipmentDate,
  receipt_date: data.receiptDate,
});

export const ShipmentEdit = () => (
  <Edit transform={transform}>
    <SimpleForm>
      <LicenseDetailsDisplay />

      <Row spacing={3}>
        <Col sm={6}>
          <TextInput
            source="trackingCode"
            label="Código de Rastreamento"
            validate={validateTrackingCode}
            fullWidth
          />
        </Col>
        <Col sm={6}>
          <TextInput
            source="plugNumber"
            label="Número do Plug"
            validate={validatePlugNumber}
            fullWidth
          />
        </Col>
      </Row>

      <Row spacing={3}>
        <Col sm={6}>
          <DateInput
            source="shipmentDate"
            label="Data da Remessa"
            validate={validateDate}
            fullWidth
          />
        </Col>
        <Col sm={6}>
          <DateInput
            source="receiptDate"
            label="Data de Recebimento (Opcional)"
            fullWidth
          />
        </Col>
      </Row>
    </SimpleForm>
  </Edit>
);
